export const events = {
  createCycle: 'Create cycle',
}
